import React, { useState } from 'react'
import moment from 'moment'
import { CSmartTable } from '@coreui/react-pro'
import CommonService from 'src/service/CommonService'
import ToastComponent from 'src/components/common/TaostComponent'
import TableSearchToolbar from 'src/components/common/TableSearchToolbar'
import RowActionsMenu from 'src/components/common/RowActionsMenu'
import StatusBadge from 'src/components/common/StatusBadge'
import Notify from '../Notify'

const SEARCH_FIELDS = [
  { key: 'first_name', label: 'First Name' },
  { key: 'last_name', label: 'Last Name' },
  { key: 'email', label: 'Email' },
  { key: 'invite_code', label: 'Code' },
]

const SENT_STATUS = {
  0: { label: 'Not Sent', tone: 'secondary' },
  1: { label: 'Sent', tone: 'success' },
  2: { label: 'Joined', tone: 'info' },
}

const MemberCodeListing = (props) => {
  const [searchField, setSearchField] = useState('first_name')

  const clearSearchKeys = (filter) => {
    const next = { ...filter }
    SEARCH_FIELDS.forEach((f) => delete next[f.key])
    return next
  }

  const applySearch = (value) => {
    const next = clearSearchKeys(props.columnFilter)
    if (value) next[searchField] = value
    props.setColumnFilter(next)
  }

  const handleFieldChange = (key) => {
    setSearchField(key)
    props.setColumnFilter(clearSearchKeys(props.columnFilter))
  }

  const sendCode = (id) => {
    CommonService.sendInviteCode(id).then((res) => {
      if (res.status === 200) {
        ToastComponent(res.message, 'success')
        props.fetchData()
      }
    })
  }

  const [showConfirm, setShowConfirm] = useState(false)
  const [handleNo, setHandleNo] = useState(false)
  const [handleYes, setHandleYes] = useState(false)
  const [tableId, setTableId] = useState(false)
  const [nextStatus, setNextStatus] = useState(false)
  const handleAreYouSureStatus = (id, status) => {
    setTableId(id)
    setNextStatus(status)
    setShowConfirm(true)
  }
  const handleConfirm = () => {
    CommonService.changeGameCodeStatus(tableId, nextStatus).then((res) => {
      if (res.status === 200) {
        props.fetchData()
        ToastComponent(res.message, 'success')
      }
    })
    return setShowConfirm(false)
  }
  const handleCancel = () => setShowConfirm(false)

  const columns = props.columns.map((c) => ({ ...c, filter: false }))
  const activeSearchLabel = SEARCH_FIELDS.find((f) => f.key === searchField)?.label

  return (
    <>
      <TableSearchToolbar
        fields={SEARCH_FIELDS}
        field={searchField}
        onFieldChange={handleFieldChange}
        value={props.columnFilter?.[searchField] || ''}
        onSearch={applySearch}
        placeholder={`Search by ${activeSearchLabel}...`}
      />
      <div className="ge-datatable">
        <CSmartTable
          columns={columns}
          columnSorter={{ external: true }}
          scopedColumns={{
            created_at: (item) => <td>{moment(item.updated_at).format('D.MM.YYYY')}</td>,
            is_sent: (item) => {
              const status = SENT_STATUS[item.is_sent] || SENT_STATUS[0]
              return (
                <td>
                  <StatusBadge label={status.label} tone={status.tone} />
                </td>
              )
            },
            actions: (item) => (
              <td>
                <RowActionsMenu
                  actions={[
                    item.is_sent === 0 && {
                      label: 'Send',
                      onClick: () => sendCode(item.id),
                    },
                    item.is_sent === 1 && {
                      label: 'Re-send',
                      onClick: () => sendCode(item.id),
                    },
                    item.is_sent === 2 && { label: 'Joined', disabled: true },
                    {
                      label: item.is_active === 1 ? 'Deactivate' : 'Activate',
                      danger: item.is_active === 1,
                      onClick: () => handleAreYouSureStatus(item.id, item.is_active === 1 ? 0 : 1),
                    },
                  ].filter(Boolean)}
                />
              </td>
            ),
          }}
          items={props.users?.data}
          itemsPerPage={props.itemsPerPage}
          itemsPerPageSelect
          loading={props.loading}
          pagination={{ external: true }}
          paginationProps={{
            activePage: props.activePage,
            pages: Math.ceil(props.users?.total / props.itemsPerPage) || 1,
          }}
          tableProps={{ hover: true, responsive: true, className: 'align-middle mb-0' }}
          onActivePageChange={(activePage) => props.setActivePage(activePage)}
          onItemsPerPageChange={(itemsPerPage) => {
            props.setActivePage(1)
            props.setItemsPerPage(itemsPerPage)
          }}
          onSorterChange={(sorter) => props.setColumnSorter(sorter)}
        />
      </div>
      <Notify
        setShowConfirm={setShowConfirm}
        showConfirm={showConfirm}
        setHandleNo={setHandleNo}
        handleNo={handleNo}
        setHandleYes={setHandleYes}
        handleYes={handleYes}
        handleConfirm={handleConfirm}
        handleCancel={handleCancel}
        text="Are You Sure Want to Change Status"
      />
    </>
  )
}

export default MemberCodeListing
